var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33463 1.66671V3.20006C7.33463 3.9468 7.33463 4.32017 7.47996 4.60538C7.60779 4.85626 7.81176 5.06024 8.06265 5.18807C8.34786 5.33339 8.72123 5.33339 9.46797 5.33339H11.0013M11.3346 6.87585V9.33337C11.3346 11.2002 11.3346 12.1336 10.9713 12.8467C10.6517 13.4739 10.1418 13.9838 9.5146 14.3034C8.80156 14.6667 7.86814 14.6667 6.0013 14.6667C4.13446 14.6667 3.20104 14.6667 2.488 14.3034C1.86079 13.9838 1.35086 13.4739 1.03128 12.8467C0.667969 12.1336 0.667969 11.2002 0.667969 9.33337V6.51882C0.667969 4.79135 0.667969 3.92762 0.980364 3.25779C1.31154 2.54769 1.88228 1.97695 2.59239 1.64577C3.26221 1.33337 4.12595 1.33337 5.85342 1.33337C6.60827 1.33337 6.9857 1.33337 7.34216 1.41241C7.72171 1.49657 8.08361 1.64647 8.4115 1.85535C8.71944 2.05151 8.98632 2.31839 9.52008 2.85216L9.77254 3.10461C10.349 3.68112 10.6373 3.96937 10.8434 4.30576C11.0262 4.604 11.1609 4.92915 11.2425 5.26927C11.3346 5.65289 11.3346 6.06054 11.3346 6.87585Z",
    stroke: "#47D06F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileIcon);
export default ForwardRef;